import styled from '@emotion/styled';
import { breakpoints } from '~/theme';
import { switchProp, ifProp } from 'styled-tools';

export const StyledTextContainer = styled.div<{ columnCount: number; centered?: boolean }>(
    ({ theme, centered, columnCount }) => ({
        margin: 'auto',
        maxWidth: centered && columnCount !== 2 ? theme.maxWidthInCharacters.lg : 'none',

        [breakpoints.md]: {
            display: centered && columnCount !== 2 ? 'flex' : 'grid',
            justifyContent: 'center',
            gridAutoFlow: 'column',
            gridTemplateColumns: `repeat(${theme.gridConfig.columnCount.md}, 1fr)`,
            gap: theme.gridConfig.gap,
            maxWidth:
                centered && columnCount !== 2
                    ? `calc(${theme.maxWidthInCharacters.lg} * ${columnCount})`
                    : 'none',
        },
    }),
    switchProp(
        'columnCount',
        {
            '1': {
                gridTemplateAreas: `". . . . ${'text '.repeat(6)} ."`,
            },
        },
        {
            gridTemplateAreas: `". ${'text '.repeat(10)} ."`,
        }
    )
);

export const StyledM100RichText = styled.div<{
    columnCount: number;
}>(
    ({ columnCount, theme }) => ({
        gridArea: 'text',
        fontSize: theme.fontSizesFluid.lg,
        maxWidth: theme.maxWidthInCharacters.lg,
        margin: '0 auto',

        [breakpoints.md]: {
            maxWidth: `calc(${theme.maxWidthInCharacters.lg} * ${columnCount})`,
        },
    }),
    ifProp(
        { columnCount: 1 },
        {
            [breakpoints.md]: {
                margin: 0,
            },
        }
    )
);

export const StyledColumns = styled.div(({ theme }) => ({
    [breakpoints.sm]: {
        display: 'grid',
        gap: theme.gridConfig.gap,
        gridAutoFlow: 'column',
    },
}));
